import ComboBox from './ComboBox';

export default ComboBox;

export type { OptionProps } from './ComboBox.constants';
